/**
 * Enterprise Motion & Animation Constants
 * Standardized across the application for consistent 60fps performance,
 * linear easing, and clear visual pacing.
 */

export const TRANSITION_LINEAR = {
    ease: "linear",
};

export const DURATION = {
    FAST: 0.1,
    NORMAL: 0.3,
    SLOW: 0.6,
    HERO: 0.9,
};

export const MOTION_VARIANTS = {
    fadeIn: {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { duration: DURATION.NORMAL, ease: "linear" },
        },
    },
    fadeInUp: {
        hidden: { opacity: 0, y: 35 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: DURATION.NORMAL, ease: "linear" },
        },
    },
    fadeInDown: {
        hidden: { opacity: 0, y: -35 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: DURATION.NORMAL, ease: "linear" },
        },
    },
    fadeInLeft: {
        hidden: { opacity: 0, x: -40 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: DURATION.NORMAL, ease: "linear" },
        },
    },
    fadeInRight: {
        hidden: { opacity: 0, x: 40 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: DURATION.NORMAL, ease: "linear" },
        },
    },
    scaleUp: {
        hidden: { opacity: 0, scale: 0.92 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: { duration: DURATION.NORMAL, ease: "linear" },
        },
    },
};
